var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.475 5.229c-.184-.106-4.56-2.566-9.466-.022-3.02 1.568-5.781.737-6.898.27V4.043A1.05 1.05 0 0 0 8.056 3 1.05 1.05 0 0 0 7 4.044v22.958c0 .577.472 1.043 1.056 1.043.583 0 1.055-.466 1.055-1.043v-8.855c.833.265 1.938.512 3.226.51 1.395 0 2.996-.286 4.654-1.146 3.839-1.996 7.273-.109 7.426-.021.324.185.726.187 1.053 0 .328-.186.53-.53.53-.904V6.131c0-.37-.2-.715-.525-.902z",
    fill: "#4884E8",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.2f1c6d8b.svg";
export { ForwardRef as ReactComponent };